import { css, styled } from '@lichtblick/styled';
import { Colors, Spacing } from '@lichtblick/theme';

export const Container = styled.div<{ $isBinding: boolean; $variant: string }>`
  align-content: center;
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: ${Spacing.Xxs};
  justify-content: center;
  min-height: 5rem;
  padding: ${Spacing.Xxs};
  min-width: 13rem;
  max-width: 13rem;
  ${({ $isBinding, $variant }) => {
    switch ($variant) {
      case 'Vor-Ort-Termin':
        return css`
          background-color: ${Colors.blue[$isBinding ? '50' : '20']};
          border-left: ${`3px solid ${Colors.blue['100']}`};
        `;
      case 'Warenlieferung':
        return css`
          background-color: ${Colors.violet[$isBinding ? '50' : '20']};
          border-left: ${`3px solid ${Colors.violet['100']}`};
        `;
      case 'DC-Montagetermin':
      case 'DC-Nachbesserungstermin (InSe-verschuldet)':
      case 'DC-Nachbesserungstermin (Kunde-verschuldet)':
        return css`
          background-color: ${Colors.red[$isBinding ? '50' : '10']};
          border-left: ${`3px solid ${Colors.red['100']}`};
        `;
      case 'AC Installation':
      case 'AC-Montagetermin':
        return css`
          background-color: ${Colors.yellow[$isBinding ? '50' : '20']};
          border-left: ${`3px solid ${Colors.yellow['100']}`};
        `;
      case 'Gerüstaufbau':
      case 'Gerüstabbau':
        return css`
          background-color: ${Colors.turquoise[$isBinding ? '50' : '20']};
          border-left: ${`3px solid ${Colors.turquoise['100']}`};
        `;
      case 'Zählersetzungstermin':
        return css`
          background-color: ${Colors.green[$isBinding ? '50' : '20']};
          border-left: ${`3px solid ${Colors.green['100']}`};
        `;
      default:
        return css`
          background-color: ${Colors.gray[$isBinding ? '50' : '20']};
          border-left: ${`3px solid ${Colors.gray['100']}`};
        `;
    }
  }}
`;

export const ItemWrapper = styled.div`
  align-items: center;
  display: flex;
  gap: ${Spacing.Xxs};
  width: 12rem;
`;

export const StatusDotWrapper = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

export const StatusDot = styled.div<{ $isBinding: boolean }>`
  background-color: ${({ $isBinding }) => ($isBinding ? Colors.green['100'] : 'transparent')};
  border: 2px solid ${Colors.green['100']};
  border-radius: 50%;
  height: 0.5rem;
  width: 0.5rem;
`;
